import styled from 'styled-components';
import { EmptyButton, getTheme, ifProp, parseTheme } from 'mol-ui';

export const Container = styled.div`
    background-color: ${ ({ theme: { dashboarBackground, dashboardWarning }, warning }) => warning ?  dashboardWarning : dashboarBackground };
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    position: relative;
    width: 100%;
`;

export const FullName = styled(EmptyButton)`
    ${ parseTheme('color', 'textColor') }
    ${ ifProp('onClick', 'cursor: pointer;') }
    font-weight: 500;
    font-size: 15px;
    margin: 0;
`;

export const Info = styled.div`
    align-items: center;
    display: flex;
    width: 90%;
`;

export const PhoneType = styled.div`
    height: 40px;
    position: absolute;
    right: 15px;
    top: calc(50% - ${ ({ topOffset }) => `${ topOffset }px` });
`;

export const Status = styled.p`
    color: ${ ({ color }) => color };
    display: inline-flex;
    font-size: .8rem;
    margin: 0;
`;

export const StatusContainer = styled.div`
    align-items: center;
    display: flex;
`;

export const Text = styled.p`
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: ${ ({ fontSize }) => fontSize ? fontSize : '13px' };
    margin: 0;
    opacity: 0.5;
`;

export const TrackingContainer = styled(EmptyButton)`
    align-items: center;
    display: inline-flex;
    justify-content: center;
    height: 100%;
    margin-right: 5px;
`;

export const Underline = styled.span`
    text-decoration: underline;
`;

export const Warning = styled.p`
    color: ${ ({ theme: { accentColor } }) => accentColor };
    font-size: .7rem;
    margin: 0;
`;
